import ScrollToHelper from '../../00_utilities/helpers/ScrollToHelper';

class SkipLinks {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        this.initElementSkipLink();
    }

    initElementSkipLink() {
        if (!this.elem.classList.contains('skip-links--page-top')) {
            const links = this.elem.querySelectorAll('a');
            for (const link of links) {
                link.addEventListener('click', (event) => {
                    const nextElement = this.findNextIdElement(event.currentTarget);
                    ScrollToHelper.scrollTo(document.getElementById(nextElement));
                });
            }
        }
    }

    findNextIdElement(currentTarget) {
        let nextElement = currentTarget.closest('.component-container').nextSibling;
        if (!nextElement) {
            nextElement = document.getElementById('footer');
        }

        if (!nextElement) {
            return null;
        }

        return nextElement.id;
    }
}

export default SkipLinks;
